define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SrCrParcel = void 0;
    class SrCrParcel extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "CrId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CrIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Segpar", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SegparError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "OrigSrId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "OrigSrIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "OrigSrSegment", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "OrigSrSegmentError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "OrigStatus", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "OrigStatusError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "OrigClassification", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "OrigClassificationError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "OrigType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "OrigTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Shape", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrCr", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, SrCrParcel.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.SrCr = parent;
            this.CrId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.SrCr = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.CrId = (0, EntityUtil_1.toInt)(entity.CrId);
            a.Segpar = (0, EntityUtil_1.toInt)(entity.Segpar);
            a.OrigSrId = b.OrigSrId;
            a.OrigSrSegment = b.OrigSrSegment;
            a.OrigStatus = b.OrigStatus;
            a.OrigClassification = b.OrigClassification;
            a.OrigType = b.OrigType;
            a.Shape = (0, EntityUtil_1.mergePolygon)(a.Shape, b.Shape);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, SrCrParcel.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqNumber(validationState, "CrId", "Change Request Application ID");
                this.validateReqNumber(validationState, "Segpar", "SEGPAR");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                CrId: this.CrId,
                Segpar: this.Segpar,
                OrigSrId: this.OrigSrId,
                OrigSrSegment: this.OrigSrSegment,
                OrigStatus: this.OrigStatus,
                OrigClassification: this.OrigClassification,
                OrigType: this.OrigType,
                Shape: this.Shape.toJSON(),
                IsGeometryModified: this.IsGeometryModified,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
    }
    exports.SrCrParcel = SrCrParcel;
    Object.defineProperty(SrCrParcel, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "SrCrParcel"
    });
    Object.defineProperty(SrCrParcel, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "SRN Change Request Parcel"
    });
    Object.defineProperty(SrCrParcel, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "CrId", "Segpar", "OrigSrId", "OrigSrSegment", "OrigStatus", "OrigClassification", "OrigType", "Shape"]
    });
    Object.defineProperty(SrCrParcel, "CrIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(SrCrParcel, "SegparReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(SrCrParcel, "OrigSrIdLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 64
    });
    Object.defineProperty(SrCrParcel, "OrigSrIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(SrCrParcel, "OrigSrSegmentLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(SrCrParcel, "OrigSrSegmentReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(SrCrParcel, "OrigStatusLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 20
    });
    Object.defineProperty(SrCrParcel, "OrigStatusDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(SrCrParcel, "OrigStatusReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(SrCrParcel, "OrigClassificationLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 20
    });
    Object.defineProperty(SrCrParcel, "OrigClassificationDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(SrCrParcel, "OrigClassificationReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(SrCrParcel, "OrigTypeLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(SrCrParcel, "OrigTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(SrCrParcel, "OrigTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrParcel.prototype, "CrId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrParcel.prototype, "CrIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrParcel.prototype, "Segpar", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrParcel.prototype, "SegparError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrParcel.prototype, "OrigSrId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrParcel.prototype, "OrigSrIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrParcel.prototype, "OrigSrSegment", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrParcel.prototype, "OrigSrSegmentError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrParcel.prototype, "OrigStatus", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrParcel.prototype, "OrigStatusError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrParcel.prototype, "OrigClassification", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrParcel.prototype, "OrigClassificationError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrParcel.prototype, "OrigType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrParcel.prototype, "OrigTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrParcel.prototype, "Shape", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrParcel.prototype, "SrCr", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], SrCrParcel.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], SrCrParcel.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], SrCrParcel.prototype, "merge", null);
});
